<template>
  <div class="recommendationPop">
    <div class="pop_close" @click="popclose">
      <img v-if="theme === 2" src="@/assets/popcloseW.svg" />
      <img v-else src="@/assets/popcloseB.svg" />
    </div>
    <el-input
      v-model="inputtext"
      type="textarea"
      resize="none"
      class="textpop"
    ></el-input>
    <div class="textbotton" @click.stop="addjianyi"><span>提交</span></div>
  </div>
</template>

<script setup>
import { onMounted, defineEmits, ref, computed } from "vue";
import { AddRecommendation } from "@/api";
import { useStore } from "vuex";

const emit = defineEmits(["updateData"]);
const popclose = () => {
  emit("popclose");
};
const store = useStore();
const inputtext = ref();
const theme = computed(() => {
  return store.state.app.theme;
});

const addjianyi = () => {
  store.commit("app/SET_MESSAGE", "close");
  if (inputtext.value === "" || inputtext.value === undefined) {
    setTimeout(() => {
      store.commit("app/SET_MESSAGE", "warn");
    }, 0);
    return;
  }
  AddRecommendation({ text: inputtext.value })
    .then(() => {
      store.commit("app/SET_MESSAGE", "succ");
    })
    .catch();
};
</script>

<style lang="scss" scoped>
.recommendationPop {
  width: 20rem;
  height: 20rem;
  border-radius: 1rem;
  background: var(--aboutpop-bac);
  border: 1px solid var(--carditem-item-border1);
  position: absolute;
  top: 5rem;
  right: 16rem;
  animation: popin 0.7s ease-in forwards;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .textbotton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    font-size: 0.8rem;
    color: var(--AddRecommendationPop--color);
    background: var(--carditem-item-bac);
    border-radius: 100%;
    position: absolute;
    bottom: -1rem;
    right: 0;
    transform: translateX(50%);
    transform: translate(50%);
    border: 1px solid var(--carditem-item-border1);
    cursor: pointer;
  }
  .textbotton:hover {
    background: var(--carditem-item-hover);
  }
  .el-textarea {
    width: 70%;
    height: 70%;
  }
  .textpop ::v-deep .el-textarea__inner {
    height: 100%;
    background: var(--AddRecommendationPop--bac);
    color: var(--AddRecommendationPop--color);
    box-shadow: 0 0 0 1px var(--AddRecommendationPop--border) inset;
  }
  .textpop ::v-deep .el-textarea__inner::-webkit-scrollbar {
    width: 0.5rem;
    background: var(--searchdetails-scrollbar-bac);
  }
  .textpop ::v-deep .el-textarea__inner::-webkit-scrollbar-thumb {
    background: var(--searchdetails-scrollbar-thumb);
  }
}
</style>